import { HttpInterceptorFn } from '@angular/common/http';
import { WEB_DEVICE_TYPE } from '@core/constants';
import { StorageKey } from '@core/enums';
import { getLocalStorageValue } from '@core/utils';

/**
 * Puts the signed-in person's headers on every request: who (`userid`, `token`, `mac`), when and where (`currentdate`,
 * `timezone`), and the partner the portal is acting for (`hospitalid` — the header name is historic). Signed out, only the two
 * fixed headers go. Reads storage through the one shared helper (review MR !1 S27: it used to keep its own copy).
 */
export const authInterceptor: HttpInterceptorFn = (request, next) =>
    next(request.clone({ setHeaders: authHeaders() }));

/** The device's id; a fresh one when none is stored (the sign-in screens store it). */
function deviceToken(): string {
    return getLocalStorageValue(StorageKey.DeviceToken) || String(Math.round(+new Date() / 1000));
}

function authHeaders(): Record<string, string> {
    const headers: Record<string, string> = {};

    const userId = getLocalStorageValue(StorageKey.UserId);
    if (userId) {
        headers['userid'] = userId;
        headers['currentdate'] = JSON.stringify(Number(new Date()));
        headers['timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
        headers['token'] = getLocalStorageValue(StorageKey.AuthToken) || '';
        headers['mac'] = deviceToken();
    }

    const hospitalId = getLocalStorageValue(StorageKey.HospitalId);
    if (hospitalId) {
        headers['hospitalid'] = hospitalId;
    }

    headers['type'] = 'heroes';
    headers['devicetype'] = WEB_DEVICE_TYPE;
    return headers;
}
